export default __webpack_public_path__ + "static/media/gamedesign.07fedf3c.png";